// @flow

import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { withRouter } from 'react-router';
import { Container, Row } from 'reactstrap';

import LodgesSummary from './LodgesSummary';
import FlightSummary from './FlightSummary';
import AdditionalServices from './AdditionalServices';
import PassengerDetailSummary from './PassengerDetailSummary';
import { Stripe, InjectInvoiceData } from '../../../../components';

import { Summary } from '../../Common';

type Props = {
  history: Object,
  location: {
    pathname: string,
  },
};

// Note: Both SelfGuided and Guided Payment Document Titles are changed in Summary Component
// @see screens/treks/common/Summary

const Payment = (props: Props) => (
  <InjectInvoiceData>
    {({ invoice, invoiceId, lineItems }) => {
      const filterLineItemsBy = type => lineItems.filter(l => l.itemType === type);

      const { amount: totalAmount, status } = invoice;
      const flightsInvoice: Array<Object> = filterLineItemsBy('flight');
      const isFlightInvoice: boolean = !isEmpty(flightsInvoice);

      const lodges: Array<Object> = filterLineItemsBy('lodge');
      const porters: Array<Object> = filterLineItemsBy('porter');
      const leaders: Array<Object> = filterLineItemsBy('leader');
      const guides: Array<Object> = filterLineItemsBy('guide');

      const isInvoicePending: boolean = status.toLowerCase() === 'pending';

      const noOfFlights: number = isFlightInvoice
        ? flightsInvoice[0].itemData.returnFlightDetails
          ? 2
          : 1
        : 0;
      return (
        <Container>
          <Row>
            {isInvoicePending && (
              <Stripe
                invoiceId={invoiceId}
                amount={totalAmount}
                onSuccess={() => {
                  props.history.push(`${props.location.pathname}/payment-success`);
                }}
                userName={isFlightInvoice ? flightsInvoice[0].itemData.contactName : null}
                userEmail={isFlightInvoice ? flightsInvoice[0].itemData.contactEmail : null}
                userPhoneNumber={
                  isFlightInvoice ? flightsInvoice[0].itemData.contactMobile : null
                }
              />
            )}
            <Summary invoice={invoice}>
              {isFlightInvoice && (
                <FlightSummary
                  flightDetails={flightsInvoice[0].itemData.flightDetails}
                  returnFlightDetails={flightsInvoice[0].itemData.returnFlightDetails}
                  totalAmount={flightsInvoice[0].amount}
                  unitPrice={Number(flightsInvoice[0].amount) / noOfFlights}
                />
              )}
              <LodgesSummary lodges={lodges} />
              <AdditionalServices porters={porters} leaders={leaders} guides={guides} />
              {isFlightInvoice && (
                <PassengerDetailSummary
                  passengers={flightsInvoice[0].itemData.passengerDetail}
                />
              )}
            </Summary>
          </Row>
        </Container>
      );
    }}
  </InjectInvoiceData>
);

export default withRouter(Payment);



// WEBPACK FOOTER //
// ./src/screens/Trek/Self-Guided/Payment/Payment.js